// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"23990236","75":"c7f2184e","291":"09a577c1","420":"0090ac43","503":"32552e72","552":"8b4f240c","645":"a4b94fbc","666":"b2b1aafe","680":"3dac66a9","773":"b8de9755","809":"18762048","878":"f6bbcf87","971":"7340a460"}[chunkId] + ".chunk.css";
};